import { Fragment } from 'react';
import dynamic from 'next/dynamic';
import {
  ErrorBoundaryWithSuspense,
  AssetDetailsContentSkeletonForTradePage,
} from '../layouts';
import { css } from '@bts-web/utils-style-engine';

const MAX_NR_OF_TRANSACTIONS = 3;

const AssetDetailsController = dynamic(
  () =>
    import('./AssetDetailsController.server').then(
      (mod) => mod.AssetDetailsController,
    ),
  {
    ssr: true,
    loading: () => <AssetDetailsHeaderSkeleton />,
  },
);

const AssetDetailsHeaderSkeleton = dynamic(
  () =>
    import('./AssetDetailsLoadingSkeleton.server').then(
      (mod) => mod.AssetDetailsHeaderSkeleton,
    ),
  {
    ssr: true,
    loading: () => <Fragment />,
  },
);

const HiddenDesktop = dynamic(
  () => import('../layouts').then((mod) => mod.HiddenDesktop),
  {
    ssr: true,
    loading: () => <div />,
  },
);

const AssetDetailsFloatingCTASpacer = dynamic(
  () =>
    import(
      './components/sections/AssetDetailsFloatingCTA/AssetDetailsFloatingCTA'
    ).then((mod) => mod.AssetDetailsFloatingCTASpacer),
  {
    loading: () => null,
  },
);

const AssetDetailsControllerWithSuspense = ({
  assetId,
  latestTransactionsFetchCount = MAX_NR_OF_TRANSACTIONS,
  hideTradeCTAFloatingButton,
}: {
  assetId: string;
  latestTransactionsFetchCount?: number;
  hideTradeCTAFloatingButton?: boolean;
}) => {
  return (
    <div className={css({ minHeight: '100vh' })}>
      <ErrorBoundaryWithSuspense
        fallbackOrSkeleton={<AssetDetailsContentSkeletonForTradePage />}
      >
        <AssetDetailsController
          assetId={assetId}
          latestTransactionsFetchCount={latestTransactionsFetchCount}
          hideTradeCTAFloatingButton={hideTradeCTAFloatingButton}
        />
      </ErrorBoundaryWithSuspense>

      {!hideTradeCTAFloatingButton && (
        <HiddenDesktop>
          <AssetDetailsFloatingCTASpacer />
        </HiddenDesktop>
      )}
    </div>
  );
};

export { AssetDetailsControllerWithSuspense };
